(function () {

  let lastColor = null;

  document.addEventListener('click', function (e) {

    const label = e.target.closest('.only_swach_color .swatches__form--label');
    if (!label) return;

    lastColor = label.dataset.swatchColor;
    if (!lastColor) return;

    // Wait until Forge finishes ALL URL updates
    function applyColor() {
      const url = new URL(window.location.href);

      if (!url.searchParams.get('variant')) {
        requestAnimationFrame(applyColor);
        return;
      }

      // Forge may re-run replaceState multiple times
      if (url.searchParams.get('color') !== lastColor) {
        url.searchParams.set('color', lastColor);
        window.history.replaceState({}, '', url.pathname + url.search);
        requestAnimationFrame(applyColor);
      }
    }

    requestAnimationFrame(applyColor);

  }, true); // capture phase is CRITICAL

})();



document.addEventListener("click", function(e) {
  if (e.target.closest(".estimator-shipping")) {
    document.querySelector(".delivery_return_button")?.click();
  }
});

document.querySelectorAll('.c-accordion').forEach(function(accordion) {
  const content = accordion.querySelector('.rte.mb0');

  if (content) {
    // Remove whitespace and <br> tags
    const cleaned = content.innerHTML
      .replace(/<br\s*\/?>/gi, '') // remove <br>
      .replace(/\s/g, ''); // remove spaces

    if (cleaned === '') {
      accordion.classList.add('is-empty');
    }
  }
});


document.addEventListener('click', function (e) {
    const headerInner = e.target.closest('.more-color-header-inner');

    if (!headerInner) return;

    const parent = headerInner.parentElement;

    parent.classList.toggle('isopen');
});

document.addEventListener('click', function (e) {
    const headerInner = e.target.closest('.instock-header-inner');

    if (!headerInner) return;

    const parent = headerInner.parentElement;

    parent.classList.toggle('isclose');
});